@if (loading) {
  <div class="overlay">
    <div class="center">
      <uilab-mat-progress-spinner
        class="example-margin"
        [color]="'primary'"
        [mode]="'indeterminate'"
        [value]="50"
        >
      </uilab-mat-progress-spinner>
    </div>
  </div>
}
